import http from '../http-common'
class DataService {
    log (data) {
        return http.post('/log', data);
    }
}

export default new DataService()
